import * as types from "./mutationTypes";

export default {
  [types.SET_CONTROL_PANEL](state, organization) {
    state.organization = { ...organization };
  },
  [types.CLEAR_CONTROL_PANEL](state) {
    state.organization = null;
  },
  [types.SET_REPORT](state, report) {
    state.report = report;
  },
  [types.CLEAR_REPORT](state) {
    state.report = null;
  },
  [types.SET_REPORT_RANGE](state, reportRange) {
    state.reportRange = reportRange;
  },
  [types.CLEAR_REPORT_RANGE](state) {
    state.reportRange = null;
  },
  [types.SET_BILLING_CYCLE](state, value) {
    state.organization.billing_cycle = value;
  },
  [types.SET_CONTRACTED_CREDITS](state, value) {
    state.organization.contracted_credits = value;
  },
  [types.SET_CONTRACT_EXPIRATION](state, value) {
    state.organization.contract_expiration = value;
  },
  [types.SET_DUE_DATE](state, value) {
    state.organization.due_date = value;
  },
  [types.SET_RESPONSIBLE](state, value) {
    state.organization.cs_uuid = value;
  },
  [types.SET_ACTIVATE](state, value) {
    state.organization.inactivated_at = value;
  },
  [types.SET_REASON](state, value) {
    state.organization.reason = value;
  }
};
